import { TContractor } from '@typedefs/contractors';
import { TWorker } from '@typedefs/workers';
import { TLocation } from '@typedefs/locations';
// import type { IAlarm } from '@typedefs/alarms';
// import type { IEvent } from '@typedefs/events';
import { defineStore } from 'pinia';

interface IGlobalStore {
  isSidebarMinimized: boolean;
  contractors: TContractor[];
  locations: TLocation[];
  workerRequests: TWorker[];
  adhocWorkerRequests: TWorker[];
  // activeAlarms: IAlarm[];
  // openedDoors: IEvent[];
}

const emptyGlobalStore: IGlobalStore = {
  isSidebarMinimized: false,
  contractors: [],
  locations: [],
  workerRequests: [],
  adhocWorkerRequests: [],
  // activeAlarms: [],
  // openedDoors: [],
};

export const useGlobalStore = defineStore('global', {
  state: (): IGlobalStore => emptyGlobalStore,
  // state: () => {
  //   return {
  //     isSidebarMinimized: false,
  //   };
  // },

  actions: {
    toggleSidebar() {
      this.isSidebarMinimized = !this.isSidebarMinimized;
    },
    updateContractors(contractors: TContractor[]) {
      this.contractors = contractors;
    },
    updateLocations(locations: TLocation[]) {
      this.locations = locations;
    },
    updateWorkerRequests(workerRequests: TWorker[]) {
      this.workerRequests = workerRequests;
    },
    updateAdhocWorkerRequests(adhocWorkerRequests: TWorker[]) {
      this.adhocWorkerRequests = adhocWorkerRequests;
    },
    // updateActiveAlarms(activeAlarms: IAlarm[]) {
    //   this.activeAlarms = activeAlarms;
    // },
    // updateOpenedDoors(openedDoors: IEvent[]) {
    //   this.openedDoors = openedDoors;
    // },
  },

  getters: {
    getContractors(state) {
      return state.contractors;
    },
    getLocations(state) {
      return state.locations;
    },
    getWorkerRequests(state) {
      return state.workerRequests;
    },
    getAdhocWorkerRequests(state) {
      return state.adhocWorkerRequests;
    },
    // getActiveAlarms(state) {
    //   return state.activeAlarms;
    // },
    // getOpenedDoors(state) {
    //   return state.openedDoors;
    // },
  },
});
